module.exports = __webpack_public_path__ + "1dbf8f58835ffea973031e5c6d04700a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boat-shoes-blue.png
// module id = 2488
// module chunks = 0